import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ButtonModule } from 'primeng/button';

@Component({
  selector: 'div[CustomCreateButton]',
  standalone: true,
  imports: [
    CommonModule, ButtonModule
  ],
  template: `
    <button type="button" pButton icon="pi pi-plus" class="p-button-rounded p-button-outlined"
    (click)="handleClick()" [disabled]="disabled"></button>
  `
})
export class CustomCreateButton {
  @Output() onClick = new EventEmitter<void>();
  @Input() disabledBtn = false;

  handleClick(): void {
    this.onClick.emit();
  }

  get disabled(): boolean {
    return this.disabledBtn;
  }
}
